// extracted by mini-css-extract-plugin
module.exports = {"form-disabled":"SVGExportForm_form-disabled___nm_P","header-disabled":"SVGExportForm_header-disabled__v0GtR"};